import { graphHooks } from '@tunasong/graph-lib/react'
import type { PollOption } from '@tunasong/schemas'
import { EntityLink } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { hasOwnLabel } from './option-label.js'
import css from './poll-option-name.module.css'

export interface PollOptionNameProps {
  option: Pick<PollOption, 'name' | 'entityRef'>
}

/**
 * The one place an option's display is decided. The human label is the option; a linked entity
 * is the secondary reference beneath it, still one click away. With no label the entity link is
 * all there is, exactly as before labels existed. The entity itself is never renamed.
 */
export const PollOptionName: FC<PollOptionNameProps> = props => {
  const { option } = props
  const { entity } = graphHooks.useEntity(option.entityRef)

  if (!(option.entityRef && entity)) {
    return <>{option.name}</>
  }

  if (!hasOwnLabel(option, entity.name)) {
    return <EntityLink entity={entity} />
  }

  return (
    <span className={css.root}>
      <span className={css.label}>{option.name}</span>
      <span className={css.reference}>
        <EntityLink entity={entity} />
      </span>
    </span>
  )
}

export default PollOptionName
